import React from "react";
import classnames from "classnames";
import styles from "./SegmentedControl.module.scss";

export interface SegmentedControlItem {
    key: string;
    label: string;
}

export interface SegmentedControlProps {
    items: SegmentedControlItem[];
    value: string;
    onChange: (key: string) => void;
    className?: string;
    ariaLabel?: string;
}

/**
 * Сегментированный переключатель (например, «Заявки / Сводка»): один выбранный пункт из нескольких.
 * Если пунктов меньше двух — выбирать не из чего, ничего не рисуется. Касание пункта — не меньше 44×44.
 */
export const SegmentedControl = ({ items, value, onChange, className, ariaLabel }: SegmentedControlProps) => {
    if (items.length < 2) {
        return null;
    }

    return (
        <div className={classnames(styles.control, className)} role="tablist" aria-label={ariaLabel}>
            {items.map((item) => {
                const selected = item.key === value;

                return (
                    <button
                        key={item.key}
                        type="button"
                        role="tab"
                        aria-selected={selected}
                        className={classnames(styles.item, { [styles.selected]: selected })}
                        onClick={() => onChange(item.key)}
                    >
                        {item.label}
                    </button>
                );
            })}
        </div>
    );
};
